import {Col, Container, Row, Button} from "react-bootstrap";
import AgGridPageSizeSelect from "../AgGridPageSizeSelect";
import React, {useContext, useEffect, useState} from "react";
import useWindowDimensions from "hooks/Dimensions";
import ColumnsModal from "./ColumnsModal";
import DeleteModal from "./DeleteModal";
import RenameModal from "./RenameModal";
import ActionModal from "../ActionModal";
import RightSideOptions from "./RightSideOptions";
import RenameButton from "./ToolBarButtons/RenameButton";
import DeleteButton from "./ToolBarButtons/DeleteButton";
import ExportButton from "./ToolBarButtons/ExportButton";
import ColumnsButton from "./ToolBarButtons/ColumnsButton";
import SaveQueryButton from "./ToolBarButtons/SaveQueryButton";
import ResetTableButton from "./ToolBarButtons/ResetTableButton";
import SSARequestListButton from "./ToolBarButtons/SSARequestListButton";
import RefreshOptionsModal from "./RefreshOptionsModal";
import DirectionOptionsModal from "./DirectionOptionsModal";
import ExportModal from "./ExportModal";
import RefreshOptionsButton from "./ToolBarButtons/RefreshOptionsButton";
import DirectionButton from "./ToolBarButtons/DirectionButton";
import SaveModal from "./SaveModal";
import {ActionPanelContext} from "../../context/action";
import FitToWindowButton from "./ToolBarButtons/FitToWindowButton";
import CancelTradeButton from "./ToolBarButtons/CancelTradeButton";
import ClearSelectionButton from "./ToolBarButtons/ClearSelectionButton"
import CancelTradeModal from "./CancelTradeModal";
import StatusOptionsModal from "./StatusOptionsModal";
import ApproveButton from "./ToolBarButtons/ApproveButton";
import WireApproveModal from "./WireApproveModal";
import WireRejectModal from "./WireRejectModal";
import AdminMobileToolbar from "./AdminMobileToolbar";
import StatusButton from "./ToolBarButtons/StatusButton";
import { ToastContext } from "../../context/Toast";
import ToolbarRefresh from "./ToolbarRefresh";
import DownloadToolbarButton from "./ToolBarButtons/DownloadToolbarButton";
import CancelAssetTransferModal from "./CancelAssetTransferModal";
import CancelAssetTransferButton from "./ToolBarButtons/CancelAssetTransferButton";
import CompleteSwiftWiresButton from "./ToolBarButtons/CompleteSwiftWiresButton";
import CompleteSwiftWiresModal from "./CompleteSwiftWiresModal";
import CompleteButton from "./ToolBarButtons/CompleteButton";
import RejectButton from "./ToolBarButtons/RejectButton";
import RefreshButton from "./ToolBarButtons/RefreshButton";
import SwiftTransactionCompleteModal from "./SwiftTransactionCompleteModal";
import SwiftTransactionRejectModal from "./SwiftTransactionRejectModal";

const toolBarColStyle = {
    padding: 0, paddingRight: 20, textAlign: "center", alignSelf: "center"
};

export default function AgGridToolbar(props) {
    const {gridColumnApi, gridApi, sizeToFit, shortSaleApprovalScreen,swiftWiresScreen, securitiesLending, ssaPersistDetails, handleSwiftWiresComplete, swiftMessageScreen,
        isSaved, mnyWiresScreen, wireTemplateScreen, fileName, tradeScreen, swiftTransactionScreen, assetTransferUploadScreen,wireTemplateUploadScreen, assetTransferScreen, queryScreen, tradeBreak, wireScreen, reportScreen, onPageRequest,
        refreshCriteria, columnDefs, setColumnDefs, pasteFromExcelPanel, headerCheckboxChecked, onClearButtonClick, selectedRows, handleCancelTrade, selectedAnyCheckbox,
        paginationPageSize,setPaginationPageSize, showButton, setShowButton, columnState, fileType, handleDownload, handleAssetTransferCancel, onRefresh, handleSwiftTransactionComplete} = props;
    const title = props.title ?? "Queries Results";
    const [show, setShow] = useState(false)
    const [showRename, setShowRename] = useState(false)
    const [showSave, setSave] = useState(false)
    const [showDelete, setShowDelete] = useState(false)
    const [showExport, setShowExport] = useState(false)
    const [showColumns, setShowColumns] = useState(false)
    const [showRefreshOptions, setShowRefreshOptions] = useState(false)
    const [showColumnDropdown, setShowColumnDropdown] = useState(false)
    const [showExportDropdown, setShowExportDropdown] = useState(false)
    const [showRightSideOptions,setShowRightSideOptions] = useState(false);
    const [showBackButton, setShowBackButton] =  useState(false);
    const [showCancelTrade, setShowCancelTrade] = useState(false);
    const [showApprove, setShowApprove] = useState(false);
    const [showStatusOptions, setShowStatusOptions] = useState(false);
    const [showDirectionOptions, setShowDirectionOptions] = useState(false);
    const [showCancelAssetTransfer, setShowCancelAssetTransfer] = useState(false);
    const [showCompleteSwiftWires, setShowCompleteSwiftWires] = useState(false);
    const { alert } = useContext(ToastContext);
    const [showComplete, setShowComplete] = useState(false);
    const [showSwiftTxReject, setShowSwiftTxReject] = useState(false);
    const [showReject, setShowReject] = useState(false);
    const [completeReason, setCompleteReason] = useState('');
    const [completeComment, setCompleteComment] = useState('');
    const [rejectComment, setRejectComment] = useState('');
    const {isDesktop, isMobile} = useWindowDimensions();
    let confirmDeleteBtnClassName = "btn btn-block ";
    confirmDeleteBtnClassName += isDesktop ? 'td-btn-primary-light' : 'td-btn-red ';

    const hasLinkedWires = (template) => template?.linkedToWire === 'Y';

    const getDeleteConfirmationMessage = () => {
        if (!wireTemplateScreen) {
            return undefined;
        }

        const selectedTemplates = gridApi?.getSelectedRows?.() || [];
        const deletingTemplatesLinkedToWires = selectedTemplates.some(hasLinkedWires);

        return deletingTemplatesLinkedToWires
            ? 'There are wires against Template(s) you are trying to Delete, Are you sure you want to delete the template?'
            : 'Are you sure you want to delete the template(s) you selected?';
    }

    let confirmCancelBtnClassName  = "btn btn-block ";
    confirmCancelBtnClassName += isDesktop ? 'td-btn-primary-light' : 'td-btn-red ';

    const { setSavedSearchName, isValidApprover, isValidRejecter } = useContext(ActionPanelContext);

    useEffect(()=>{
        if(props && props.title)
            setSavedSearchName(props.title)
    },[]);


    const handleResetTableButtonClick=()=> {
        if(props && props.columnDefs && props.columnDefs.length > 0) {
            gridApi.setFilterModel(null);
            const colDef = [...props.columnDefs]
            colDef.map(e => e.hide = !!e.suppressColumnsToolPanel);
            gridApi.setColumnDefs(colDef)
            setColumnDefs(colDef)
            gridColumnApi.resetColumnState();
        }
    }

    const handleColumnFilterClick=(colDef)=> {
        gridApi.setColumnDefs(colDef)
        setShowColumns(false);
        setShow(false);
        setColumnDefs(colDef);
        setShowColumnDropdown(false);
    }

    const modalBody=()=>{
        if (showColumns)
            return (<ColumnsModal columnDefs={columnDefs} setColumnDefs={setColumnDefs} gridApi={gridApi} onColumnFilterClick={handleColumnFilterClick}/>)
        else if(showExport)
            return (<ExportModal gridApi={gridApi} showExport={showExport} setShowExport={setShowExport} setShow={setShow} isDropDown={true}/>)
        else if(showDelete)
            return (<DeleteModal setShowDelete={setShowDelete} setShow={setShow} confirmDeleteBtnClassName={confirmDeleteBtnClassName} gridApi={gridApi} confirmationMessage={getDeleteConfirmationMessage()}/>)
        else if(showRename)
            return (<RenameModal allowSpecialCharacters={props.allowSpecialCharacters} setShow={setShow} setShowRename={setShowRename}/>)
        else if(showSave)
            return (<SaveModal setShow={setShow} setSave={setSave}/>)
        else if(showRefreshOptions)
            return (<RefreshOptionsModal setShow={setShow} gridApi={gridApi} setShowRefreshOptions={setShowRefreshOptions} setShowRightSideOptions={setShowRightSideOptions} rowData={props.rowData} refreshCriteria={refreshCriteria} />)
        else if (showStatusOptions)
            return (<StatusOptionsModal refreshCriteria={refreshCriteria} gridApi={gridApi} rowData={props.rowData} setShow={setShow} setShowRefreshOptions={setShowRefreshOptions} setShowRightSideOptions={setShowRightSideOptions} setShowStatusOptions={setShowStatusOptions} />)
        else if(showDirectionOptions)
            return (<DirectionOptionsModal refreshCriteria={refreshCriteria} gridApi={gridApi} rowData={props.rowData} setShow={setShow} setShowRefreshOptions={setShowRefreshOptions} setShowRightSideOptions={setShowRightSideOptions} setShowDirectionOptions={setShowDirectionOptions} />)
        else if(showRightSideOptions)
            return (<RightSideOptions />)
        else if (showApprove)
            return (<WireApproveModal setShow={setShow} setShowApprove={setShowApprove} gridApi={gridApi} showReferenceFields={mnyWiresScreen} />)
        else if (showReject)
            return (<WireRejectModal setShow={setShow} setShowReject={setShowReject} gridApi={gridApi} />)
        else if (showCompleteSwiftWires)
            return (<CompleteSwiftWiresModal setShowCompleteSwiftWires={setShowCompleteSwiftWires} setShow={setShow} confirmCancelBtnClassName={confirmCancelBtnClassName} gridApi={gridApi} selectedRows={selectedRows} />)
        else if(showCancelTrade)
            return (<CancelTradeModal setShowCancelTrade={setShowCancelTrade} setShow={setShow} confirmCancelBtnClassName={confirmCancelBtnClassName} gridApi={gridApi} selectedRows={selectedRows}/>)
        else if(showCancelAssetTransfer)
            return (<CancelAssetTransferModal setShowCancelAssetTransfer={setShowCancelAssetTransfer} setShow={setShow} confirmCancelBtnClassName={confirmCancelBtnClassName} gridApi={gridApi} selectedRows={selectedRows}/>)
        else if(showComplete)
            return (
                <SwiftTransactionCompleteModal
                    setShow={setShow}
                    completeReason={completeReason}
                    setCompleteReason={setCompleteReason}
                    completeComment={completeComment}
                    setCompleteComment={setCompleteComment}
                    completeOptions={props.completeOptions}
                    onCancel={handleHide}
                    setShowComplete = {setShowComplete}
                    selectedRows={selectedRows}
                    onApprove={() => {
                        if (props.onCompleteSubmit) {
                            props.onCompleteSubmit({reason: completeReason, comment: completeComment});
                        }
                        handleHide();
                    }}
                />
            )
        else if (showSwiftTxReject)
            return (
                <SwiftTransactionRejectModal
                    setShow={setShow}
                    setShowSwiftTxReject = {setShowSwiftTxReject}
                    onCancel={handleHide}
                    selectedRows={selectedRows}
                />
            )
    }

    const handleHide = ()=>{
        setShowRename(false)
        setSave(false)
        setShowDelete(false)
        setShowExport(false)
        setShowColumns(false)
        setShow(false)
        setShowRightSideOptions(false)
        setShowBackButton(false)
        setShowComplete(false)
        setShowCompleteSwiftWires(false)
        setShowApprove(false)
        setShowReject(false)
        setShowStatusOptions(false);
        setShowDirectionOptions(false);
        setShowSwiftTxReject(false)
    }

    const actionTitle=()=> {
        if (showExport) return 'Export'
        if (showRename) return ' Rename'
        if (showSave) return 'Save Search'
        if (showDelete) return 'Delete'
        if (showColumns) return 'Columns'
        if (showStatusOptions) return "Status"
        if (showRefreshOptions) return 'Refresh Options'
        if (showDirectionOptions) return 'Direction'
        if (showApprove) return isValidApprover ? 'Approve' : 'Error'
        if (showReject) return isValidRejecter ? 'Reject' : 'Error'
        if (showCancelTrade) return 'Cancel Trade'
        if (showCancelAssetTransfer) return 'Cancel Asset Transfer'
        if (showCompleteSwiftWires) {
            const multipleSelected = gridApi.getSelectedRows().length > 1
            return multipleSelected?"Multiple Wire Selected":'Complete'
        }
        if(showCancelAssetTransfer) return 'Cancel Asset Transfer'
        if (showComplete) return 'Complete'
        if (showSwiftTxReject) return 'Reject'
    }

    const handleShowRightSideOptions=()=>{
        setShowRightSideOptions(true);
    }

    const handleGoBackClick=()=>{
        setShowRename(false)
        setSave(false)
        setShowDelete(false)
        setShowExport(false)
        setShowColumns(false)
        setShow(false)
        setShowBackButton(false)
        setShowRefreshOptions(false)
        setShowDirectionOptions(false)
        setShowApprove(false)
        setShowReject(false)
        setShowStatusOptions(false);
        setShowCompleteSwiftWires(false);
        setShowComplete(false);
        setShowSwiftTxReject(false)
    }

    const handleRenameClick=()=>{
        setShowRename(true);
        setShow(true);
        setShowBackButton(isMobile);
    }

    const handleCancelTradeClick = ()=>{
        handleCancelTrade();
        setShowCancelTrade(true);
        setShow(true);
        setShowBackButton(isMobile);
    }

    const handleAssetTransferCancelClick = ()=>{
        handleAssetTransferCancel();
        setShowCancelAssetTransfer(true);
        setShow(true);
        setShowBackButton(isMobile);
    }
    const handleSwiftWiresCompleteClick = ()=>{
        if (!selectedAnyCheckbox) {
            return;
        }
        handleSwiftWiresComplete();
        setShowRightSideOptions(false);
        setShowCompleteSwiftWires(true);
        setShow(true);
        setShowBackButton(isMobile);
    }

    const handleClearClick = ()=> {
        onClearButtonClick();
    }


    const handleDeleteButtonClick=()=>{
        setShowDelete(true);
        setShow(true);
        setShowBackButton(isMobile);
    }

    const handleExportButtonClick=()=>{
        setShowExport(true)
        setShow(true)
        setShowBackButton(isMobile);
    }

    const handleColumnsButtonClick=()=>{
        setShowColumns(true)
        setShow(true)
        setShowBackButton(true);
    }

    const handleSaveQueryButtonClick=()=>{
        setSave(true)
        setShow(true)
    }
    const handleRefreshOptionsButtonClick=()=>{
        setShow(true);
        setShowRefreshOptions(true);
        setShowBackButton(isMobile);
    }
    const handleCompleteClick = ()=>{
        if (!selectedAnyCheckbox) {
            return;
        }
        handleSwiftTransactionComplete();
        setShowRightSideOptions(false);
        setShowComplete(true);
        setShow(true);
        setShowBackButton(isMobile);
    }

    const handleRejectClick = ()=>{
        if (!selectedAnyCheckbox) {
            return;
        }
        handleSwiftTransactionComplete();
        setShowRightSideOptions(false);
        setShowSwiftTxReject(true);
        setShow(true);
        setShowBackButton(isMobile);
    }

    const handleRefreshClick = () => {
        if (onRefresh) {
            onRefresh();
        }
    }

    const handleDirectionOptionsButtonClick=()=>{
        setShow(true);
        setShowDirectionOptions(true);
        setShowBackButton(isMobile);
    }

    const handleApproveButtonClick = () => {
        if (gridApi.getSelectedRows().length === 0) {
            alert("Select an item to approve");
            return;
        }
        setShow(true)
        setShowApprove(true)

    }
    const handleRejectButtonClick = () => {
        if (gridApi.getSelectedRows().length === 0) {
            alert("Select an item to reject");
            return;
        }
        setShow(true)
        setShowReject(true)
    }

    const handleStatusButtonClicked = () => {
        setShow(true);
        setShowStatusOptions(true);
        setShowBackButton(isMobile);
    }
    const handleDirectionButtonClicked = () => {
        setShow(true);
        setShowDirectionOptions(true);
        setShowBackButton(isMobile);
    }
    const adminHandleDeleteButtonClick = () => {
        if (gridApi.getSelectedRows().length === 0) {
            alert("Select a template to delete");
            return;
        }
        setShowDelete(true);
        setShow(true);
        setShowBackButton(isMobile);
    }

    if (shortSaleApprovalScreen) return (<>
        <Container fluid style={{background: "#F3F3F3", padding: 0, margin: 0, border: "1px solid rgba(0,0,0,.15)", borderBottom: 0}}>
            <Row style={{margin: 0, padding: 0}} >
                <Col style={{paddingLeft: 0, paddingRight: 0}}>
                    <Container style={{width: "100%", marginRight: 0, paddingRight: 10}}
                               className={"justify-content-end navbar"}>
                        <Row>
                            <RightSideOptions show={showRightSideOptions} setShow={setShowRightSideOptions} onShowRightSideOptions={handleShowRightSideOptions} onHide={handleHide}>
                                {!pasteFromExcelPanel &&
                                    <>
                                        <Col style={toolBarColStyle} className="text-nowrap">
                                            <ExportButton onExportButtonClick={handleExportButtonClick} title={"Export"} showDropdown={showExportDropdown} setShowDropdown={setShowExportDropdown} gridApi={gridApi} showExport={showExport} setShowExport={setShowExport} setShow={setShow}/>
                                        </Col>
                                        <Col style={toolBarColStyle} className="text-nowrap d-block py-0 align-self-center d-sm-none">
                                            <RefreshOptionsButton onRefreshOptionsButtonClick={handleRefreshOptionsButtonClick} refreshCriteria={refreshCriteria} gridApi={gridApi} rowData={props.rowData}/>
                                        </Col>
                                        {!isMobile && <RefreshOptionsModal refreshCriteria={refreshCriteria} gridApi={gridApi} rowData={props.rowData}/> }
                                    </>
                                }
                                <Col xs={"auto"} style={{padding: 0}} className={'d-none d-sm-block'}>
                                    <AgGridPageSizeSelect gridApi={gridApi}
                                                          paginationPageSize={paginationPageSize}
                                                          setPaginationPageSize={setPaginationPageSize}
                                                          showButton={showButton}
                                                          setShowButton={setShowButton}/>
                                </Col>
                            </RightSideOptions>
                        </Row>

                    </Container>
                </Col>
            </Row>
            <Row>
                <Col xs={"auto"}>
                    <ActionModal body={modalBody} title={actionTitle} show={show}  onHide={handleHide} dialogClassName={isDesktop ? '': isMobile? 'fullscreen-dialog' : 'custom-dialog'} centered={isDesktop} showBackButton={showBackButton} onGoBackClick={handleGoBackClick}/>
                </Col>
            </Row>
        </Container>
    </>);
   else if (swiftWiresScreen) return (<>
        <Container fluid style={{ background: "#F3F3F3", padding: 0, margin: 0, border: "1px solid rgba(0,0,0,.15)", borderBottom: 0 }}>
            <Row style={{ margin: 0, padding: 0 }} >
                <Col style={{ paddingLeft: 0, paddingRight: 0 }}>
                    <Container style={{ width: "100%", marginRight: 0, paddingRight: 10 }}
                               className={"justify-content-end navbar"}>
                        <Row>
                            <RightSideOptions show={showRightSideOptions} setShow={setShowRightSideOptions} onShowRightSideOptions={handleShowRightSideOptions} onHide={handleHide}>
                                <Col style={toolBarColStyle} className="text-nowrap">
                                    <CompleteSwiftWiresButton onCompleteSwiftWiresClick={handleSwiftWiresCompleteClick} buttonTitle="Complete" disabled={!selectedAnyCheckbox}/>
                                </Col>
                                <Col style={toolBarColStyle} className="text-nowrap">
                                    <ExportButton onExportButtonClick={handleExportButtonClick} title={"Export"}
                                                      showDropdown={showExportDropdown} setShowDropdown={setShowExportDropdown}
                                                      gridApi={gridApi} showExport={showExport} setShowExport={setShowExport}
                                                      setShow={setShow} />
                                </Col>
                                <Col style={toolBarColStyle} className="text-nowrap d-md-none">
                                    <DirectionButton onDirectionButtonClick={handleDirectionButtonClicked}
                                                     setShow={setShow} />
                                </Col>
                                {!isMobile && <DirectionOptionsModal refreshCriteria={refreshCriteria} gridApi={gridApi} rowData={props.rowData} setShowDirectionOptions={setShowDirectionOptions} />}
                                <Col xs={"auto"} style={{ padding: 0 }} className={'d-none d-sm-block'}>
                                    <AgGridPageSizeSelect gridApi={gridApi}
                                                          paginationPageSize={paginationPageSize}
                                                          setPaginationPageSize={setPaginationPageSize}
                                                          showButton={showButton}
                                                          setShowButton={setShowButton} />
                                </Col>
                            </RightSideOptions>
                        </Row>
                    </Container>
                </Col>
            </Row>
            <Row>
                <Col xs={"auto"}>
                    <ActionModal body={modalBody} title={actionTitle} show={show} onHide={handleHide} dialogClassName={isDesktop ? '' : isMobile ? 'fullscreen-dialog' : 'custom-dialog'} centered={isDesktop} showBackButton={showBackButton} onGoBackClick={handleGoBackClick} />
                </Col>
            </Row>
        </Container>
    </>);

    else if (swiftMessageScreen) return (<>
        <Container fluid style={{background: "#F3F3F3", padding: 0, margin: 0, border: "1px solid rgba(0,0,0,.15)", borderBottom: 0}}>
            <Row style={{margin: 0, padding: 0}} >
                <Col style={{paddingLeft: 0, paddingRight: 0}}>
                    <Container style={{width: "100%", marginRight: 0, paddingRight: 10}}
                               className={"justify-content-end navbar"}>
                        <Row>
                            <RightSideOptions show={showRightSideOptions} setShow={setShowRightSideOptions} onShowRightSideOptions={handleShowRightSideOptions} onHide={handleHide}>
                                {!pasteFromExcelPanel &&
                                    <>
                                        <Col style={toolBarColStyle} className="text-nowrap">
                                            <ExportButton onExportButtonClick={handleExportButtonClick} title={"Export"} showDropdown={showExportDropdown} setShowDropdown={setShowExportDropdown} gridApi={gridApi} showExport={showExport} setShowExport={setShowExport} setShow={setShow}/>
                                        </Col>

                                    </>
                                }
                                <Col xs={"auto"} style={{padding: 0}} className={'d-none d-sm-block'}>
                                    <AgGridPageSizeSelect gridApi={gridApi}
                                                          paginationPageSize={paginationPageSize}
                                                          setPaginationPageSize={setPaginationPageSize}
                                                          showButton={showButton}
                                                          setShowButton={setShowButton}/>
                                </Col>
                            </RightSideOptions>
                        </Row>

                    </Container>
                </Col>
            </Row>
            <Row>
                <Col xs={"auto"}>
                    <ActionModal body={modalBody} title={actionTitle} show={show}  onHide={handleHide} dialogClassName={isDesktop ? '': isMobile? 'fullscreen-dialog' : 'custom-dialog'} centered={isDesktop} showBackButton={showBackButton} onGoBackClick={handleGoBackClick}/>
                </Col>
            </Row>
        </Container>
    </>);

    else if (securitiesLending) return (<>
        <Container fluid style={{background: "#F3F3F3", padding: 0, margin: 0, border: "1px solid rgba(0,0,0,.15)", borderBottom: 0}}>
            <Row style={{margin: 0, padding: 0}}>
                <Col xs={"auto"} style={{textAlign: "left", alignSelf: "center"}}>
                    <RenameButton title={fileName} onRenameClick={handleRenameClick} editable={!isMobile}/>
                </Col>
                <Col style={{paddingLeft: 0, paddingRight: 0}}>
                    <Container style={{width: "100%", marginRight: 0, paddingRight: 10}} className={"justify-content-end navbar"}>
                        <Row>
                            <RightSideOptions show={showRightSideOptions} setShow={setShowRightSideOptions} onShowRightSideOptions={handleShowRightSideOptions} onHide={handleHide}>
                                <Col style={toolBarColStyle} className="text-nowrap d-block d-sm-none">
                                    <RenameButton title={fileName} onRenameClick={handleRenameClick} editable={true}/>
                                </Col>
                                <Col style={toolBarColStyle} className="text-nowrap d-block py-0 align-self-center">
                                    <DeleteButton onDeleteButtonClick={handleDeleteButtonClick} buttonTitle="Delete"/>
                                </Col>
                                <Col style={toolBarColStyle} className="text-nowrap d-block py-0 d-sm-none align-self-center">
                                    <RefreshOptionsButton onRefreshOptionsButtonClick={handleRefreshOptionsButtonClick} refreshCriteria={refreshCriteria} gridApi={gridApi} rowData={props.rowData}/>
                                </Col>
                                <Col style={toolBarColStyle} className="text-nowrap py-0">
                                    <SSARequestListButton onPageRequest={onPageRequest}/>
                                </Col>
                                {!isMobile && <RefreshOptionsModal /> }
                                <Col xs={"auto"} style={{padding: 0}} className={'d-none d-sm-block'}>
                                    <AgGridPageSizeSelect gridApi={gridApi}
                                                          paginationPageSize={paginationPageSize}
                                                          setPaginationPageSize={setPaginationPageSize}
                                                          showButton={showButton}
                                                          setShowButton={setShowButton}/>
                                </Col>
                            </RightSideOptions>
                        </Row>
                    </Container>
                </Col>
            </Row>
            <Row>
                <Col xs={"auto"}>
                    <ActionModal body={modalBody} title={actionTitle} show={show}  onHide={handleHide} dialogClassName={isDesktop ? '': isMobile? 'fullscreen-dialog' : 'custom-dialog'} centered={isDesktop} showBackButton={showBackButton} onGoBackClick={handleGoBackClick}/>
                </Col>
            </Row>
        </Container>
    </>);
    else if (ssaPersistDetails) return (<>
        <Container fluid style={{background: "#F3F3F3", padding: 0, margin: 0, border: "1px solid rgba(0,0,0,.15)", borderBottom: 0}}>
            <Row style={{margin: 0, padding: 0}}>
                <Col xs={"auto"} style={{textAlign: "left", alignSelf: "center"}}>
                    <RenameButton title={fileName} onRenameClick={handleRenameClick} editable={!isMobile}/>
                </Col>
                <Col style={{paddingLeft: 0, paddingRight: 0}}>
                    <Container style={{width: "100%", marginRight: 0, paddingRight: 10}} className={"justify-content-end navbar"}>
                        <Row>
                            <RightSideOptions show={showRightSideOptions} setShow={setShowRightSideOptions} onShowRightSideOptions={handleShowRightSideOptions} onHide={handleHide}>
                                <Col style={toolBarColStyle} className="text-nowrap">
                                    <ExportButton onExportButtonClick={handleExportButtonClick} title={"Export"} showDropdown={showExportDropdown} setShowDropdown={setShowExportDropdown} gridApi={gridApi} showExport={showExport} setShowExport={setShowExport} setShow={setShow}/>
                                </Col>
                                <Col style={toolBarColStyle} className="text-nowrap d-block d-sm-none">
                                    <RenameButton title={fileName} onRenameClick={handleRenameClick} editable={true}/>
                                </Col>
                                <Col style={toolBarColStyle} className="text-nowrap d-block py-0 align-self-center">
                                    <DeleteButton onDeleteButtonClick={handleDeleteButtonClick} buttonTitle="Delete"/>
                                </Col>
                                <Col style={toolBarColStyle} className="text-nowrap py-0">
                                    <SSARequestListButton onPageRequest={onPageRequest}/>
                                </Col>
                            </RightSideOptions>
                        </Row>
                    </Container>
                </Col>
            </Row>
            <Row>
                <Col xs={"auto"}>
                    <ActionModal body={modalBody} title={actionTitle} show={show}  onHide={handleHide} dialogClassName={isDesktop ? '': isMobile? 'fullscreen-dialog' : 'custom-dialog'} centered={isDesktop} showBackButton={showBackButton} onGoBackClick={handleGoBackClick}/>
                </Col>
            </Row>
        </Container>
    </>);
    else if (queryScreen || wireScreen) return (<>
        <Container fluid style={{background: "#F3F3F3", padding: 0, margin: 0, border: "1px solid rgba(0,0,0,.15)", borderBottom: 0}}>
            <Row style={{margin: 0, padding: 0}}>
                <Col xs={"auto"} style={{textAlign: "left", alignSelf: "center"}} className={`${isSaved?'d-block ':'d-none'}`}>
                    <RenameButton title={title} onRenameClick={handleRenameClick} editable={!isMobile}/>
                </Col>
                <Col style={{paddingLeft: 0, paddingRight: 0}}>
                    <Container style={{width: "100%", marginRight: 0, paddingRight: 0}}
                               className={"justify-content-end navbar"}>
                        <Row style={{marginRight: 0, paddingRight: 0}}>
                            <RightSideOptions show={showRightSideOptions} setShow={setShowRightSideOptions} onShowRightSideOptions={handleShowRightSideOptions} onHide={handleHide}>
                                <Col style={toolBarColStyle} className={`text-nowrap d-sm-none ${isSaved?'':'d-none'}`}>
                                    <RenameButton onRenameClick={handleRenameClick} editable={true}/>
                                </Col>
                                <Col style={toolBarColStyle} className={`text-nowrap  ${isSaved?'d-none':'d-block'}`}>
                                    <SaveQueryButton onSaveQueryButtonClick={handleSaveQueryButtonClick}/>
                                </Col>
                                <Col style={toolBarColStyle} className={`text-nowrap py-0 align-self-center ${isSaved?' d-block':'d-none'}`}>
                                    <DeleteButton onDeleteButtonClick={handleDeleteButtonClick} buttonTitle="Delete"/>
                                </Col>
                                <Col style={toolBarColStyle} className="text-nowrap d-none d-sm-block">
                                    <ResetTableButton onResetTableButtonClick={handleResetTableButtonClick}/>
                                </Col>
                                <Col style={toolBarColStyle} className="text-nowrap">
                                    <ColumnsButton onColumnsButtonClick={handleColumnsButtonClick} title={"Columns"} showDropdown={showColumnDropdown} setShowDropdown={setShowColumnDropdown} columnDefs={columnDefs} setColumnDefs={setColumnDefs} gridApi={gridApi} onColumnFilterClick={handleColumnFilterClick} gridColumnApi={gridColumnApi}/>
                                </Col>
                                <Col style={toolBarColStyle} className="text-nowrap">
                                    <ExportButton onExportButtonClick={handleExportButtonClick} title={"Export"} showDropdown={showExportDropdown} setShowDropdown={setShowExportDropdown} gridApi={gridApi} showExport={showExport} setShowExport={setShowExport} setShow={setShow}/>
                                </Col>
                                <Col xs={"auto"} style={{padding: 0}} className={'d-none d-sm-block'}>
                                    <AgGridPageSizeSelect gridApi={gridApi}
                                                          paginationPageSize={paginationPageSize}
                                                          setPaginationPageSize={setPaginationPageSize}
                                                          showButton={showButton}
                                                          setShowButton={setShowButton}/>
                                </Col>
                            </RightSideOptions>
                        </Row>
                    </Container>
                </Col>
            </Row>
            <Row className={'p-0 m-0'}>
                <Col xs={"12"} className={'p-0 m-0'}>
                    <ActionModal body={modalBody} title={actionTitle} show={show}  onHide={handleHide} dialogClassName={isDesktop ? '': isMobile ? 'fullscreen-dialog' : 'custom-dialog'} centered={isDesktop} showBackButton={showBackButton} onGoBackClick={handleGoBackClick}/>
                </Col>
            </Row>
        </Container>
    </>);
    else if (tradeScreen) return (<>
        <Container fluid style={{background: "#F3F3F3", padding: 0, margin: 0, border: "1px solid rgba(0,0,0,.15)", borderBottom: 0}}>
            <Row style={{margin: 0, padding: 0}}>

                {(headerCheckboxChecked || selectedAnyCheckbox)?
                    <>
                        <Col xs={"auto"} style={{textAlign: "left", alignSelf: "center"}} className='d-block'>
                            <CancelTradeButton onCancelTradeClick={handleCancelTradeClick} editable={!isMobile} buttonTitle="Cancel Trade"/>
                        </Col>
                        <Col xs={"auto"} style={{textAlign: "left", alignSelf: "center"}} className='d-block'>
                            <ClearSelectionButton onClearSelectionClick={handleClearClick} editable={!isMobile} buttonTitle="Clear"/>
                        </Col>
                    </>
                    :
                    <Col xs={"auto"} style={{textAlign: "left", alignSelf: "center"}} className={`${isSaved?'d-block ':'d-none'}`}>
                        <RenameButton title={title} onRenameClick={handleRenameClick} editable={!isMobile}/>
                    </Col>
                }
                <Col style={{paddingLeft: 0, paddingRight: 0}}>
                    <Container style={{width: "100%", marginRight: 0, paddingRight: 0}}
                               className={"justify-content-end navbar"}>
                        <Row style={{marginRight: 0, paddingRight: 0}}>
                            <RightSideOptions show={showRightSideOptions} setShow={setShowRightSideOptions} onShowRightSideOptions={handleShowRightSideOptions} onHide={handleHide}>
                                {(!headerCheckboxChecked || !selectedAnyCheckbox) &&
                                    <>
                                        <Col style={toolBarColStyle} className={`text-nowrap d-sm-none ${isSaved?'':'d-none'}`}>
                                            <RenameButton onRenameClick={handleRenameClick} editable={true}/>
                                        </Col>
                                        <Col style={toolBarColStyle} className={`text-nowrap  ${isSaved?'d-none':'d-block'}`}>
                                            <SaveQueryButton onSaveQueryButtonClick={handleSaveQueryButtonClick}/>
                                        </Col>
                                        <Col style={toolBarColStyle} className={`text-nowrap py-0 align-self-center ${isSaved?' d-block':'d-none'}`}>
                                            <DeleteButton onDeleteButtonClick={handleDeleteButtonClick} buttonTitle="Delete"/>
                                        </Col>
                                        <Col style={toolBarColStyle} className="text-nowrap d-none d-sm-block">
                                            <ResetTableButton onResetTableButtonClick={handleResetTableButtonClick}/>
                                        </Col>
                                        <Col style={toolBarColStyle} className="text-nowrap">
                                            <ColumnsButton onColumnsButtonClick={handleColumnsButtonClick} title={"Columns"} showDropdown={showColumnDropdown} setShowDropdown={setShowColumnDropdown} columnDefs={columnDefs} setColumnDefs={setColumnDefs} gridApi={gridApi} onColumnFilterClick={handleColumnFilterClick} gridColumnApi={gridColumnApi} columnState={columnState}/>
                                        </Col>
                                        <Col style={toolBarColStyle} className="text-nowrap">
                                            <ExportButton onExportButtonClick={handleExportButtonClick} title={"Export"} showDropdown={showExportDropdown} setShowDropdown={setShowExportDropdown} gridApi={gridApi} showExport={showExport} setShowExport={setShowExport} setShow={setShow}/>
                                        </Col>
                                    </>}

                                <Col xs={"auto"} style={{padding: 0}} className={'d-none d-sm-block'}>
                                    <AgGridPageSizeSelect gridApi={gridApi}
                                                          paginationPageSize={paginationPageSize}
                                                          setPaginationPageSize={setPaginationPageSize}
                                                          showButton={showButton}
                                                          setShowButton={setShowButton}/>
                                </Col>
                            </RightSideOptions>
                        </Row>
                    </Container>
                </Col>
            </Row>
            <Row className={'p-0 m-0'}>
                <Col xs={"12"} className={'p-0 m-0'}>
                    <ActionModal body={modalBody} title={actionTitle} show={show}  onHide={handleHide} dialogClassName={isDesktop ? '': isMobile ? 'fullscreen-dialog' : 'custom-dialog'} centered={isDesktop} showBackButton={showBackButton} onGoBackClick={handleGoBackClick}/>
                </Col>
            </Row>
        </Container>
    </>);
    else if (assetTransferScreen) return (<>
        <Container fluid style={{background: "#F3F3F3", padding: 0, margin: 0, border: "1px solid rgba(0,0,0,.15)", borderBottom: 0}}>
            <Row style={{margin: 0, padding: 0}}>

                {(headerCheckboxChecked || selectedAnyCheckbox)?
                    <>
                        <Col xs={"auto"} style={{textAlign: "left", alignSelf: "center"}} className='d-block'>
                            <CancelAssetTransferButton onCancelAssetTransferClick={handleAssetTransferCancelClick} editable={!isMobile} buttonTitle="Cancel Asset Transfer"/>
                        </Col>
                        <Col xs={"auto"} style={{textAlign: "left", alignSelf: "center"}} className='d-block'>
                            <ClearSelectionButton onClearSelectionClick={handleClearClick} editable={!isMobile} buttonTitle="Clear"/>
                        </Col>
                    </>
                    :
                    <Col xs={"auto"} style={{textAlign: "left", alignSelf: "center"}} className={`${isSaved?'d-block ':'d-none'}`}>
                        <RenameButton title={title} onRenameClick={handleRenameClick} editable={!isMobile}/>
                    </Col>
                }
                <Col style={{paddingLeft: 0, paddingRight: 0}}>
                    <Container style={{width: "100%", marginRight: 0, paddingRight: 0}}
                               className={"justify-content-end navbar"}>
                        <Row style={{marginRight: 0, paddingRight: 0}}>
                            <RightSideOptions show={showRightSideOptions} setShow={setShowRightSideOptions} onShowRightSideOptions={handleShowRightSideOptions} onHide={handleHide}>
                                {(!headerCheckboxChecked || !selectedAnyCheckbox) &&
                                    <>
                                        <Col style={toolBarColStyle} className={`text-nowrap d-sm-none ${isSaved?'':'d-none'}`}>
                                            <RenameButton onRenameClick={handleRenameClick} editable={true}/>
                                        </Col>
                                        <Col style={toolBarColStyle} className={`text-nowrap  ${isSaved?'d-none':'d-block'}`}>
                                            <SaveQueryButton onSaveQueryButtonClick={handleSaveQueryButtonClick}/>
                                        </Col>
                                        <Col style={toolBarColStyle} className={`text-nowrap py-0 align-self-center ${isSaved?' d-block':'d-none'}`}>
                                            <DeleteButton onDeleteButtonClick={handleDeleteButtonClick} buttonTitle="Delete"/>
                                        </Col>
                                        <Col style={toolBarColStyle} className="text-nowrap d-none d-sm-block">
                                            <ResetTableButton onResetTableButtonClick={handleResetTableButtonClick}/>
                                        </Col>
                                        <Col style={toolBarColStyle} className="text-nowrap">
                                            <ColumnsButton onColumnsButtonClick={handleColumnsButtonClick} title={"Columns"} showDropdown={showColumnDropdown} setShowDropdown={setShowColumnDropdown} columnDefs={columnDefs} setColumnDefs={setColumnDefs} gridApi={gridApi} onColumnFilterClick={handleColumnFilterClick} gridColumnApi={gridColumnApi} columnState={columnState}/>
                                        </Col>
                                        <Col style={toolBarColStyle} className="text-nowrap">
                                            <ExportButton onExportButtonClick={handleExportButtonClick} title={"Export"} showDropdown={showExportDropdown} setShowDropdown={setShowExportDropdown} gridApi={gridApi} showExport={showExport} setShowExport={setShowExport} setShow={setShow}/>
                                        </Col>
                                    </>}

                                <Col xs={"auto"} style={{padding: 0}} className={'d-none d-sm-block'}>
                                    <AgGridPageSizeSelect gridApi={gridApi}
                                                          paginationPageSize={paginationPageSize}
                                                          setPaginationPageSize={setPaginationPageSize}
                                                          showButton={showButton}
                                                          setShowButton={setShowButton}/>
                                </Col>
                            </RightSideOptions>
                        </Row>
                    </Container>
                </Col>
            </Row>
            <Row className={'p-0 m-0'}>
                <Col xs={"12"} className={'p-0 m-0'}>
                    <ActionModal body={modalBody} title={actionTitle} show={show}  onHide={handleHide} dialogClassName={isDesktop ? '': isMobile ? 'fullscreen-dialog' : 'custom-dialog'} centered={isDesktop} showBackButton={showBackButton} onGoBackClick={handleGoBackClick}/>
                </Col>
            </Row>
        </Container>
    </>);
    else if (assetTransferUploadScreen) return (<>
        <Container fluid style={{background: "#F3F3F3", padding: 0, margin: 0, border: "1px solid rgba(0,0,0,.15)", borderBottom: 0}}>
            <Row style={{margin: 0, padding: 0}}>
                <Col style={{paddingLeft: 0, paddingRight: 0}}>
                    <Container style={{width: "100%", marginRight: 0, paddingRight: 0}}
                               className={"justify-content-end navbar"}>
                        <Row style={{marginRight: 0, paddingRight: 0}}>
                            <RightSideOptions show={showRightSideOptions} setShow={setShowRightSideOptions} onShowRightSideOptions={handleShowRightSideOptions} onHide={handleHide}>
                                <Col style={toolBarColStyle} className="text-nowrap">
                                    <ExportButton onExportButtonClick={handleExportButtonClick} title={"Export"} showDropdown={showExportDropdown} setShowDropdown={setShowExportDropdown} gridApi={gridApi} showExport={showExport} setShowExport={setShowExport} setShow={setShow}/>
                                </Col>
                                <Col xs={"auto"} style={{padding: 0}} className={'d-none d-sm-block'}>
                                    <AgGridPageSizeSelect gridApi={gridApi}
                                                          paginationPageSize={paginationPageSize}
                                                          setPaginationPageSize={setPaginationPageSize}
                                                          showButton={showButton}
                                                          setShowButton={setShowButton}/>
                                </Col>
                            </RightSideOptions>
                        </Row>
                    </Container>
                </Col>
            </Row>
            <Row className={'p-0 m-0'}>
                <Col xs={"12"} className={'p-0 m-0'}>
                    <ActionModal body={modalBody} title={actionTitle} show={show}  onHide={handleHide} dialogClassName={isDesktop ? '': isMobile ? 'fullscreen-dialog' : 'custom-dialog'} centered={isDesktop} showBackButton={showBackButton} onGoBackClick={handleGoBackClick}/>
                </Col>
            </Row>
        </Container>
    </>);
    else if (wireTemplateUploadScreen) return (<>
        <Container fluid style={{background: "#F3F3F3", padding: 0, margin: 0, border: "1px solid rgba(0,0,0,.15)", borderBottom: 0}}>
            <Row style={{margin: 0, padding: 0}}>
                <Col style={{paddingLeft: 0, paddingRight: 0}}>
                    <Container style={{width: "100%", marginRight: 0, paddingRight: 0}}
                               className={"justify-content-end navbar"}>
                        <Row style={{marginRight: 0, paddingRight: 0}}>
                            <RightSideOptions show={showRightSideOptions} setShow={setShowRightSideOptions} onShowRightSideOptions={handleShowRightSideOptions} onHide={handleHide}>
                                <Col style={toolBarColStyle} className="text-nowrap">
                                    <ExportButton onExportButtonClick={handleExportButtonClick} title={"Export"} showDropdown={showExportDropdown} setShowDropdown={setShowExportDropdown} gridApi={gridApi} showExport={showExport} setShowExport={setShowExport} setShow={setShow}/>
                                </Col>
                                <Col xs={"auto"} style={{padding: 0}} className={'d-none d-sm-block'}>
                                    <AgGridPageSizeSelect gridApi={gridApi}
                                                          paginationPageSize={paginationPageSize}
                                                          setPaginationPageSize={setPaginationPageSize}
                                                          showButton={showButton}
                                                          setShowButton={setShowButton}/>
                                </Col>
                            </RightSideOptions>
                        </Row>
                    </Container>
                </Col>
            </Row>
            <Row className={'p-0 m-0'}>
                <Col xs={"12"} className={'p-0 m-0'}>
                    <ActionModal body={modalBody} title={actionTitle} show={show}  onHide={handleHide} dialogClassName={isDesktop ? '': isMobile ? 'fullscreen-dialog' : 'custom-dialog'} centered={isDesktop} showBackButton={showBackButton} onGoBackClick={handleGoBackClick}/>
                </Col>
            </Row>
        </Container>
    </>);
    else if (swiftTransactionScreen) return (<>
        <Container fluid style={{background: "#F3F3F3", padding: 0, margin: 0, border: "1px solid rgba(0,0,0,.15)", borderBottom: 0}}>
            <Row style={{margin: 0, padding: 0}}>
                <Col style={{paddingLeft: 0, paddingRight: 0}}>
                    <Container style={{width: "100%", marginRight: 0, paddingRight: 0}}
                               className={"justify-content-end navbar"}>
                        <Row style={{marginRight: 0, paddingRight: 0}}>
                            <RightSideOptions show={showRightSideOptions} setShow={setShowRightSideOptions} onShowRightSideOptions={handleShowRightSideOptions} onHide={handleHide}>
                                <Col xs={"auto"} style={toolBarColStyle}>
                                    <CompleteButton onCompleteClick={handleCompleteClick} buttonTitle="Complete" disabled={!selectedAnyCheckbox}/>
                                </Col>
                                <Col xs={"auto"} style={toolBarColStyle}>
                                    <RejectButton onRejectButtonClick={handleRejectClick} buttonTitle="Reject" disabled={!selectedAnyCheckbox}/>
                                </Col>
                                <Col style={toolBarColStyle} className="text-nowrap d-block py-0 align-self-center">
                                    <RefreshButton onRefreshClick={handleRefreshClick} buttonTitle="Refresh"/>
                                </Col>
                                <Col style={toolBarColStyle} className="text-nowrap">
                                    <ExportButton onExportButtonClick={handleExportButtonClick} title={"Export"} showDropdown={showExportDropdown} setShowDropdown={setShowExportDropdown} gridApi={gridApi} showExport={showExport} setShowExport={setShowExport} setShow={setShow}/>
                                </Col>
                                <Col xs={"auto"} style={{padding: 0}} className={'d-none d-sm-block'}>
                                    <AgGridPageSizeSelect gridApi={gridApi}
                                                          paginationPageSize={paginationPageSize}
                                                          setPaginationPageSize={setPaginationPageSize}
                                                          showButton={showButton}
                                                          setShowButton={setShowButton}/>
                                </Col>
                            </RightSideOptions>
                        </Row>
                    </Container>
                </Col>
            </Row>
            <Row className={'p-0 m-0'}>
                <Col xs={"12"} className={'p-0 m-0'}>
                    <ActionModal body={modalBody} title={actionTitle} show={show}  onHide={handleHide} dialogClassName={isDesktop ? '': isMobile ? 'fullscreen-dialog' : 'custom-dialog'} centered={isDesktop} showBackButton={showBackButton} onGoBackClick={handleGoBackClick}/>
                </Col>
            </Row>
        </Container>
    </>);
    else if(reportScreen) return (<>
        <Container fluid style={{background: "#F3F3F3", padding: 0, margin: 0, border: "1px solid rgba(0,0,0,.15)", borderBottom: 0}}>
            <Row style={{margin: 0, padding: 0}}>
                <Col xs={"auto"} style={{textAlign: "left", alignSelf: "center"}} className={`${isSaved?'d-block ':'d-none'}`}>
                    <RenameButton title={title} onRenameClick={handleRenameClick} editable={!isMobile} />
                </Col>
                <Col style={{paddingLeft: 0, paddingRight: 0}}>
                    <Container style={{width: "100%", marginRight: 0, paddingRight: 0}}
                               className={"justify-content-end navbar"}>
                        <Row style={{marginRight: 0, paddingRight: 0}}>
                            <RightSideOptions show={showRightSideOptions} setShow={setShowRightSideOptions} onShowRightSideOptions={handleShowRightSideOptions} onHide={handleHide}>
                                <Col style={toolBarColStyle} className={`text-nowrap d-sm-none ${isSaved?'':'d-none'}`}>
                                    <RenameButton onRenameClick={handleRenameClick} editable={true}/>
                                </Col>
                                <Col style={toolBarColStyle} className={`text-nowrap py-0 align-self-center ${['csv','xlsx'].includes(fileType)?' d-block':'d-none'}`}>
                                    <DownloadToolbarButton onDownloadButtonClick={handleDownload} buttonTitle="Download"/>
                                </Col>
                                <Col style={toolBarColStyle} className={`text-nowrap py-0 align-self-center ${isSaved?' d-block':'d-none'}`}>
                                    <DeleteButton onDeleteButtonClick={handleDeleteButtonClick} buttonTitle="Delete"/>
                                </Col>
                                <Col style={toolBarColStyle} className={`text-nowrap  ${isSaved?'d-none':'d-block'}`}>
                                    <SaveQueryButton onSaveQueryButtonClick={handleSaveQueryButtonClick}/>
                                </Col>
                            </RightSideOptions>
                        </Row>
                    </Container>
                </Col>
            </Row>
            <Row className={'p-0 m-0'}>
                <Col xs={"12"} className={'p-0 m-0'}>
                    <ActionModal body={modalBody} title={actionTitle} show={show}  onHide={handleHide} dialogClassName={isDesktop ? '': isMobile ? 'fullscreen-dialog' : 'custom-dialog'} centered={isDesktop} showBackButton={showBackButton} onGoBackClick={handleGoBackClick}/>
                </Col>
            </Row>
        </Container>
    </>);
    else if (tradeBreak) return (<>
        <Container fluid style={{background: "#F3F3F3", padding: 0, margin: 0, border: "1px solid rgba(0,0,0,.15)", borderBottom: 0}}>
            <Row style={{margin: 0, padding: 0}}>
                <Col style={{paddingLeft: 0, paddingRight: 0}}>
                    <Container style={{width: "100%", marginRight: 0, paddingRight: 0}}
                               className={"justify-content-end navbar"}>
                        <Row style={{marginRight: 0, paddingRight: 0}}>
                            <RightSideOptions show={showRightSideOptions} setShow={setShowRightSideOptions} onShowRightSideOptions={handleShowRightSideOptions} onHide={handleHide}>
                                <Col className="text-nowrap">
                                    <FitToWindowButton onFitToWindowButtonClick={sizeToFit} />
                                </Col>
                                <Col style={toolBarColStyle} className="text-nowrap d-none d-sm-block">
                                    <ResetTableButton onResetTableButtonClick={handleResetTableButtonClick}/>
                                </Col>
                                <Col style={toolBarColStyle} className="text-nowrap">
                                    <ExportButton onExportButtonClick={handleExportButtonClick} title={"Export"} showDropdown={showExportDropdown} setShowDropdown={setShowExportDropdown} gridApi={gridApi} showExport={showExport} setShowExport={setShowExport} setShow={setShow}/>
                                </Col>
                                <Col style={toolBarColStyle} className="text-nowrap">
                                    <ToolbarRefresh refreshCriteria={refreshCriteria} gridApi={gridApi} rowData={props.rowData}/>
                                </Col>
                                <Col xs={"auto"} style={{padding: 0}} className={'d-none d-sm-block'}>
                                    <AgGridPageSizeSelect gridApi={gridApi}
                                                          paginationPageSize={paginationPageSize}
                                                          setPaginationPageSize={setPaginationPageSize}
                                                          showButton={showButton}
                                                          setShowButton={setShowButton}/>
                                </Col>

                            </RightSideOptions>

                        </Row>
                    </Container>
                </Col>
            </Row>
            <Row className={'p-0 m-0'}>
                <Col xs={"12"} className={'p-0 m-0'}>
                    <ActionModal body={modalBody} title={actionTitle} show={show}  onHide={handleHide} dialogClassName={isDesktop ? '': isMobile ? 'fullscreen-dialog' : 'custom-dialog'} centered={isDesktop} showBackButton={showBackButton} onGoBackClick={handleGoBackClick}/>
                </Col>
            </Row>
        </Container>
    </>);

    else if (mnyWiresScreen) return (<>
        <Container fluid style={{ background: "#F3F3F3", padding: 0, margin: 0, border: "1px solid rgba(0,0,0,.15)", borderBottom: 0 }}>
            <Row style={{ margin: 0, padding: 0 }} >
                <Col style={{ paddingLeft: 0, paddingRight: 0 }}>
                    <Container style={{ width: "100%", marginRight: 0, paddingRight: 10 }}
                               className={"justify-content-end navbar"}>
                        <Row>
                            {isMobile && <AdminMobileToolbar onApproveButtonClick={handleApproveButtonClick}
                                                             onRejectButtonClick={handleRejectButtonClick}
                                                             paginationPageSize={paginationPageSize}
                                                             setPaginationPageSize={setPaginationPageSize}
                                                             refreshCriteria={refreshCriteria}
                                                             toolBarColStyle={toolBarColStyle} />
                            }
                            <RightSideOptions show={showRightSideOptions} setShow={setShowRightSideOptions} onShowRightSideOptions={handleShowRightSideOptions} onHide={handleHide}>
                                <Col style={toolBarColStyle} className="text-nowrap d-none d-sm-block">
                                    <ApproveButton onApproveButtonClick={handleApproveButtonClick} />
                                </Col>
                                <Col style={toolBarColStyle} className="text-nowrap d-none d-sm-block">
                                    <RejectButton onRejectButtonClick={handleRejectButtonClick} />
                                </Col>
                                <Col style={toolBarColStyle} className="text-nowrap">
                                    <ExportButton onExportButtonClick={handleExportButtonClick} title={"Export"}
                                                  showDropdown={showExportDropdown} setShowDropdown={setShowExportDropdown}
                                                  gridApi={gridApi} showExport={showExport} setShowExport={setShowExport}
                                                  setShow={setShow} />
                                </Col>
                                <Col style={toolBarColStyle} className="text-nowrap d-md-none">
                                    <StatusButton onStatusButtonClick={handleStatusButtonClicked}
                                                  setShow={setShow} />
                                </Col>
                                {/*<Col style={toolBarColStyle} className="text-nowrap d-block py-0 align-self-center d-sm-none">*/}
                                {/*    <RefreshOptionsButton onRefreshOptionsButtonClick={handleRefreshOptionsButtonClick} refreshCriteria={refreshCriteria} gridApi={gridApi} rowData={props.rowData}/>*/}
                                {/*</Col>*/}
                                {!isMobile && <StatusOptionsModal mnyWiresScreen={true} refreshCriteria={refreshCriteria} gridApi={gridApi} rowData={props.rowData} setShowStatusOptions={setShowStatusOptions} />}
                                <Col xs={"auto"} style={{ padding: 0 }} className={'d-none d-sm-block'}>
                                    <AgGridPageSizeSelect gridApi={gridApi}
                                                          paginationPageSize={paginationPageSize}
                                                          setPaginationPageSize={setPaginationPageSize}
                                                          showButton={showButton}
                                                          setShowButton={setShowButton} />
                                </Col>
                            </RightSideOptions>
                        </Row>
                    </Container>
                </Col>
            </Row>
            <Row>
                <Col xs={"auto"}>
                    <ActionModal body={modalBody} title={actionTitle} show={show} onHide={handleHide} dialogClassName={isDesktop ? '' : isMobile ? 'fullscreen-dialog' : 'custom-dialog'} centered={isDesktop} showBackButton={showBackButton} onGoBackClick={handleGoBackClick} />
                </Col>
            </Row>
        </Container>
    </>);

    else if (wireTemplateScreen) return (<>
        <Container fluid style={{ background: "#F3F3F3", padding: 0, margin: 0, border: "1px solid rgba(0,0,0,.15)", borderBottom: 0 }}>
            <Row style={{ margin: 0, padding: 0 }} >
                <Col style={{ paddingLeft: 0, paddingRight: 0 }}>
                    <Container style={{ width: "100%", marginRight: 0, paddingRight: 10 }}
                               className={"justify-content-end navbar"}>
                        <Row>
                            {isMobile && <AdminMobileToolbar onApproveButtonClick={handleApproveButtonClick}
                                                             onRejectButtonClick={handleRejectButtonClick}
                                                             refreshCriteria={refreshCriteria}
                                                             onDeleteButtonClick={adminHandleDeleteButtonClick}
                                                             toolBarColStyle={toolBarColStyle} />
                            }
                            <RightSideOptions show={showRightSideOptions} setShow={setShowRightSideOptions} onShowRightSideOptions={handleShowRightSideOptions} onHide={handleHide}>
                                <Col style={toolBarColStyle} className="text-nowrap d-none d-sm-block">
                                    <ApproveButton onApproveButtonClick={handleApproveButtonClick} />
                                </Col>
                                <Col style={toolBarColStyle} className="text-nowrap d-none d-sm-block">
                                    <RejectButton onRejectButtonClick={handleRejectButtonClick} buttonTitle="Reject"/>
                                </Col>
                                <Col style={toolBarColStyle} className={`text-nowrap py-0 align-self-center`}>
                                    <DeleteButton onDeleteButtonClick={adminHandleDeleteButtonClick} buttonTitle="Delete" />
                                </Col>
                                <Col style={toolBarColStyle} className="text-nowrap">
                                    <ExportButton onExportButtonClick={handleExportButtonClick} title={"Export"} showDropdown={showExportDropdown} setShowDropdown={setShowExportDropdown} gridApi={gridApi} showExport={showExport} setShowExport={setShowExport} setShow={setShow} />
                                </Col>
                                <Col style={toolBarColStyle} className="text-nowrap d-md-none">
                                    <StatusButton onStatusButtonClick={handleStatusButtonClicked}
                                                  setShow={setShow} />
                                </Col>
                                {!isMobile && <StatusOptionsModal wireTemplateScreen={true} refreshCriteria={refreshCriteria} gridApi={gridApi} rowData={props.rowData} setShowStatusOptions={setShowStatusOptions} />}
                                <Col xs={"auto"} style={{ padding: 0 }} className={'d-none d-sm-block'}>
                                    <AgGridPageSizeSelect gridApi={gridApi} paginationPageSize={paginationPageSize} setPaginationPageSize={setPaginationPageSize} />
                                </Col>
                            </RightSideOptions>
                        </Row>
                    </Container>
                </Col>
            </Row>
            <Row>
                <Col xs={"auto"}>
                    <ActionModal body={modalBody} title={actionTitle} show={show} onHide={handleHide} dialogClassName={isDesktop ? '' : isMobile ? 'fullscreen-dialog' : 'custom-dialog'} centered={isDesktop} showBackButton={showBackButton} onGoBackClick={handleGoBackClick} />
                </Col>
            </Row>
        </Container>
    </>);
}


AgGridToolbar.defaultProps={
    allowSpecialCharacters:false
}